
import moment from "moment";
import { FormDynamic } from "./resources/FormDynamic";

export class Utils {

    static isMobile():boolean{
        return (/iphone|ipod|android|ie|blackberry|fennec/).test
        (navigator.userAgent.toLowerCase());
      }

    static innerHTML(html:string):any{

        return {__html: html};
      
    }

   static checkForm (f:FormDynamic):boolean{
        const time:any = "00:00";
        let toDay = moment(new Date()).startOf(time) 
        let dateStart = null;
        let dateEnd = null;
       

        if(f){
          
          if(!f.enabled)
            return false

          if(f.dateStart != null){
            dateStart = moment(new Date(f.dateStart)).startOf(time)
          }
          if(f.dateEnd != null){
              dateEnd = moment(new Date(f.dateEnd)).startOf(time)
          }
 
          if(dateStart !=null && dateEnd == null)
            return  (toDay.isSameOrAfter(dateStart,"date"))

          if(dateStart !=null && dateEnd != null){
        
            return  (toDay.isSameOrAfter(dateStart,"date") && toDay.isSameOrBefore(dateEnd,"date") )

          }
          
          return true
        }else{
          return false
        }
    }

    static isEmail(email:string):boolean{
      //eslint-disable-next-line
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
     
     
    }

    static isTelegram():boolean{
      const location:any = window.location.href;   
       return location && location.includes("/form-tl") 
    }


    static copyToClipboard (text:string):void  {
      console.log('text', text)
      var textField = document.createElement('textarea')
      textField.innerText = text
      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
    }

    
}